import { Pipe, PipeTransform } from '@angular/core';

import { NumberUtil } from '../utils/number.util';

@Pipe({
	name: 'numberFormatter'
})
export class NumberFormatterPipe implements PipeTransform {
	public transform(num: number, formatter: number): string {
		return NumberUtil.formatNumber(num, formatter);
	}
}
